import React from 'react';
import { connect } from 'react-redux';
import { getSelectedArea } from '../../reducers/user/preferences';
import NoContentMessage from '../common/NoContentMessage';
import { cleanForSlug } from '../../utils/urls';
import { getAreasById, getStatesById } from '../../reducers';
import FullColumnLayout from '../FullColumnLayout';
import Button from '../Button';
import ShowtimesAreaSelector from '../common/Showtimes/ShowtimesAreaSelector';
import { areaSelectorSelectArea } from '../../actions/creators/ui';
import SidebarPanel from '../SidebarPanel';
import BodyBlocker from '../BodyBlocker';

interface Props {
    area: { type: 'state' | 'area', id: number, name: string } | undefined;
    onAreaSelect: (type: string, id: number, options?: { context: string }) => void;
}

const BillboardPagePlaceholder: React.FC<Props> = ({ area, onAreaSelect }) => {
    const [areaSelectorOpen, setAreaSelectorOpen] = React.useState(false);

    if (!area) {
        return <FullColumnLayout>
            <NoContentMessage icon='fal fa-map-marker-alt' title='Cartelera'>
                <p>Por favor <strong>selecciona tu zona</strong> para ver los horarios.</p>
                <Button block primary onClick={() => setAreaSelectorOpen(true)}>Seleccionar zona</Button>
            </NoContentMessage>

            {areaSelectorOpen && <>
                <BodyBlocker />
                <SidebarPanel overBlocker>
                    <ShowtimesAreaSelector
                        animate={false}
                        cinemaSelect={false}
                        title='Seleccionar zona'
                        onClose={() => setAreaSelectorOpen(false)}
                        onSave={({ area }) => {
                            setAreaSelectorOpen(false);
                            if (area) {
                                onAreaSelect(area.type, area.id, { context: 'global' });
                            }
                        }}
                    />
                </SidebarPanel>
            </>}
        </FullColumnLayout>;
    }
    
    document.location.href = `/cartelera/${'state' === area.type ? 'estado' : 'zona'}-${area.id}/${cleanForSlug(area.name)}`;

    return null;
}

const mapStateToProps = (state, ownProps) => {
    const area = getSelectedArea(state);
    const areasById = getAreasById(state);
    const statesById = getStatesById(state);
    const areaEntity = area ? 'state' === area.type ? statesById[area.id] : areasById[area.id] : undefined;

    return {
        area: area && areaEntity ? { ...area, ...areaEntity } : undefined,
    };
}

const mapDispatchToProps = (dispatch, ownProps) => ({
    onAreaSelect: (type: string, id: number) => dispatch(areaSelectorSelectArea(type, id, { context: 'global' })),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BillboardPagePlaceholder);